import React from "react";
import Autosuggest from "react-autosuggest";
import axios from "axios";
import "./SearchSuggest.scss";
import { SEARCHPATHS } from "./SearchPaths";
import Icon from "../ui/Icon";

function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function getSuggestionValue(suggestion) {
    return suggestion.value;
}

function renderSuggestion(suggestion) {
    return (
        <a href={suggestion.link}><div>{suggestion.name}</div></a>
    );
}

function renderSectionTitle(section) {
    return (
        <strong>{section.title}</strong>
    );
}

function getSectionSuggestions(section) {
    return section.results;
}

export default class SearchSuggest extends React.Component<{}, {
        value: string;
        webid_results: any;
        neighborhood_results: any;
        agent_results: any;
        listings_results: any;
    }> {
    constructor(props) {
        super(props);
        this.state = {
            value: "",
            webid_results: {},
            neighborhood_results: {},
            agent_results: {},
            listings_results: {},
        };
    }

    public render() {
        const { value } = this.state;
        const inputProps = {
            placeholder: "Search: Neighborhood, Address, Agent, ID",
            value,
            onChange: this.onChange,
            onKeyDown: this.onKeyDown
        };
        return (
            <div className="ns-search-input-container">
                <Autosuggest
                    id="ns-suggest"
                    multiSection={true}
                    suggestions={this.getSuggestions(this.state.value)}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    renderSectionTitle={renderSectionTitle}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSectionSuggestions={getSectionSuggestions}
                    inputProps={inputProps} />
                <button onClick={this.onSubmit}> <Icon name="search"/> </button>
            </div>
        );
    }

    private getSuggestions = (value) => {
        if (value) {
            const escapedValue = escapeRegexCharacters(value.trim());
            if (escapedValue === "") {
                return [];
            }
            const newSuggestions = []
            const regex = new RegExp("^" + escapedValue, "i");
            const searchPaths = SEARCHPATHS.filter(x => regex.test(x.name))
            if (searchPaths.length > 0) {
                newSuggestions.push({
                    title: "links",
                    results: searchPaths
                })
            }
            if (this.state.webid_results[value] && this.state.webid_results[value].length > 0) {
                newSuggestions.push({
                    title: "webids",
                    results: this.state.webid_results[value],
                })
            }
            if (this.state.neighborhood_results[value] && this.state.neighborhood_results[value].length > 0) {
                newSuggestions.push({
                    title: "neighborhoods",
                    results: this.state.neighborhood_results[value],
                })
            }
            if (this.state.agent_results[value] && this.state.agent_results[value].length > 0) {
                newSuggestions.push({
                    title: "people",
                    results: this.state.agent_results[value]
                })
            }
            if (this.state.listings_results[value] && this.state.listings_results[value].length > 0) {
                newSuggestions.push({
                    title: "listings",
                    results: this.state.listings_results[value]
                })
            }
            return newSuggestions
        } else {
            return []
        }
    }

    private onSubmit = () => {
        const value = this.state.value;
        if (value) {
            window.location.href = "/search?query=" + value
        }
    }

    private onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            value: value
        })
    }

    private onSuggestionsClearRequested = () => {
    }

    private onChange = (event, { newValue, method }) => {
        if (newValue || newValue === "") {
            this.setState({
                value: newValue,
            });
            if (!(this.state.listings_results[newValue]
                || this.state.agent_results[newValue]
                || (newValue && newValue.length < 3))) {
                const newWebIdResults = {...this.state.webid_results};
                const newNeighborhoodResults = { ...this.state.neighborhood_results };
                const newAgentResults = {...this.state.agent_results};
                // const newListingsResults = {...this.state.listings_results};
                if (!isNaN(newValue) && newValue.length > 4) {
                    axios.get("/ajax/view/search_webids", {params: {search: newValue}}).then((response) => {
                        newWebIdResults[newValue] = response.data.results.map((item) => {
                            return {
                                link: `${item.id}/${item.slug}`,
                                name: `${item.street_address ?
                                    "#" + item.id + ": " +  item.street_address
                                    : "#" + item.id + ": " + item.display_address}`,
                                value: "",
                            }
                        })
                    })
                    this.setState({
                        webid_results: newWebIdResults
                    })
                }
                axios.get("/ajax/view/search_neighborhoods", {params: {search: newValue}}).then((response) => {
                    newNeighborhoodResults[newValue] = response.data.results.map((item) => {
                        return {
                            link: `Sales/${item.slug}`,
                            name: `${item.name}`,
                            value: "",
                        }
                    })
                })
                this.setState({
                    neighborhood_results: newNeighborhoodResults
                })
                axios.get("/ajax/view/search_agents", {params: {search: newValue}}).then((response) => {
                    newAgentResults[newValue] = response.data.results.map((item) => {
                        const name = []
                        if (item.fname && item.fname !== "None") {
                            name.push(item.fname)
                        }
                        if (item.lname && item.lname !== "None") {
                            name.push(item.lname)
                        }
                        return {
                            link: `/agent/${item.slug}`,
                            name: name.join(" "),
                            value: "",
                        }
                    })
                    this.setState({
                        agent_results: newAgentResults
                    })
                })
                // turned off for now

                // axios.get("/ajax/view/search_listings", {params: {search: newValue}}).then((response) => {
                //     newListingsResults[newValue] = response.data.results
                //                         .filter(item => item.street_address !== "" && item.house_num !== "")
                //                         .map((item) => {
                //         // const name = Object.values({
                //         //     num_bedrooms: item.num_bedrooms && item.num_bedrooms !== "None" ?
                //         //         `${isInt(parseFloat(item.num_bedrooms)) ?
                //         //             parseInt(item.num_bedrooms)
                //         //             : item.num_bedrooms
                //         //         } Bed` : "",
                //         //     num_bathrooms: item.num_bathrooms && item.num_bedrooms !== "None" ?
                //         //         `${isInt(parseFloat(item.num_bathrooms)) ?
                //         //             parseInt(item.num_bathrooms)
                //         //             : item.num_bathrooms
                //         //         } Bath` : "",
                //         //     price: item.price && !isNaN(parseInt(item.price)) ? `$${parseInt(item.price)}` : "",
                //         // }).filter((i) => i !== "").join(" | ")
                //         return {
                //             link: `${item.id}/${item.slug}`,
                //             // name: `${item.street_address}${name !== "" ? " - " + name : ""}`
                //             name: `${item.street_address ? item.street_address : item.display_address}`,
                //             value: "",
                //         }
                //     })
                //     this.setState({
                //         listings_results: newListingsResults
                //     })
                // })
            }
        }
    };

    private onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        switch (event.keyCode) {
          case 13: {
            event.preventDefault();
            this.onSubmit()
          }
        }
      };
}
